import { Breadcrumb as BreadcrumbAnt, ButtonProps } from 'antd'
import { IBreadCrumbItem } from 'interfaces/commons/IBreadCrumbItem'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'
import styled from 'styled-components'

const StyledBreadCrumb = styled(BreadcrumbAnt)`
  .ant-breadcrumb-link {
    cursor: pointer;
  }
  li:last-child .ant-breadcrumb-link {
    cursor: default;
  }
`

const StyledImgGoBack = styled.img`
  margin-right: 4px;
  cursor: pointer;
`

interface IProps extends ButtonProps {
  breadCrumbs: Array<IBreadCrumbItem>
}

const BreadCrumb = (props: IProps) => {
  const { breadCrumbs } = props
  const { t } = useTranslation()
  const navigate = useNavigate()
  return (
    <>
      <StyledBreadCrumb separator="|">
        <BreadcrumbAnt.Item>
          <StyledImgGoBack
            src="/images/ic-arrow-left.svg"
            alt=""
            onClick={() => navigate('/')}
          />
        </BreadcrumbAnt.Item>
        {breadCrumbs?.map((breadcrumb) => {
          return (
            <BreadcrumbAnt.Item
              key={breadcrumb.name}
              onClick={() => navigate(breadcrumb.path)}>
              {t(breadcrumb.name)}
            </BreadcrumbAnt.Item>
          )
        })}
      </StyledBreadCrumb>
    </>
  )
}

export default BreadCrumb
